import { useMutation } from "@tanstack/react-query";

import { createLevel0Resource } from "@services/level0Resource";

export const useCreateLevel0WRS = (options: Record<string, any> = {}) => {
  return useMutation(createLevel0Resource, {
    ...options,
  });
};
